var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7a3826ac37a9602ba771f1f2c0b16b147984d291"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: 'https://1b0fb7ac3b8fa94406a8994ee473bd99@o124216.ingest.us.sentry.io/4506984017297408',

  integrations: [
    Sentry.replayIntegration({
      maskAllText: false
    }),
    Sentry.browserProfilingIntegration(),
    Sentry.browserTracingIntegration()
  ],

  replaysOnErrorSampleRate: process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ? 1 : 0,

  replaysSessionSampleRate: process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ? 1 : 0,

  sampleRate: process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ? 0.25 : 0,

  tracesSampleRate: process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ? 0.02 : 0
})
